<section *ngIf="facility$ | async as facility">
  <div class="container">
    <digital-platform-breadcrumbs
      [nestedBreadcrumbItem]="breadcrumbs"
      class="mt-5"
    ></digital-platform-breadcrumbs>
    <div class="row d-block mt-2 mb-6">
      <a href="javascript:history.back()" class="text-decoration-none">
        <digital-platform-icon
          icon="arrow-back"
          color="secondary"
        ></digital-platform-icon>
        <span class="text-secondary underline-on-hover fw-600">Back</span>
      </a>
    </div>
    <h1 class="mb-8">{{ facility.facility_name }}</h1>
    <div class="row">
      <div class="facility-map-container col-xl-7 col-sm-12 pe-xl-10">
        <digital-platform-bing-map
          [homepin]="facility"
          [isFacilityMap]="isFacilityMap"
        ></digital-platform-bing-map>
      </div>
      <div
        class="col-xl-5 col-sm-12 mt-10 mt-xl-0 px-6 px-xl-0 fs-14 d-flex flex-column justify-content-center"
      >
        <div class="d-flex flex-column">
          <digital-platform-rsx-a
            [url]="formatAddress(facility)"
            target="_blank"
            rel="noopener"
            class="fw-600 mb-5"
            klass="text-decoration-none"
            data-automation-id="facility-address-link"
          >
            <span [innerHtml]="facility.address"></span>
            <br />
            {{ facility.city }}, {{ facility.state }} {{ facility.zip_code }}
          </digital-platform-rsx-a>
          <a
            *ngIf="facility.phone_number"
            [href]="formatPhoneNumber(facility)"
            class="text-decoration-none fw-600 mb-5 hover-bold"
          >
            {{ facility.phone_number }}
          </a>

          <digital-platform-rsx-a
            *ngFor="let websiteLink of websiteLinks"
            [url]="websiteLink.url[0].uri"
            [target]="websiteLink.aTarget?.value"
            rel="noopener"
            class="fw-600 mb-5"
            klass="text-decoration-none"
            data-automation-id="facility-website-link"
          >
            <span [innerHtml]="websiteLink.url[0].title"></span>
          </digital-platform-rsx-a>
        </div>
        <p class="mb-4">
          <span
            *ngFor="let facility of facility.facility_types; let last = last"
            class="fs-12"
          >
            {{ facility.type }}{{ last ? '' : ', ' }}
          </span>
        </p>
        <hr class="my-3" />
        <div *ngIf="facility.epa_id">
          <p class="mt-5 text-black" data-automation-id="epa-id">
            EPA ID#: {{ facility.epa_id }}
          </p>
          <hr class="my-3" />
        </div>
        <div *ngIf="facility.facility_description" class="mt-5 text-black">
          <div
            [innerHTML]="cleanHtml(facility.facility_description)"
            data-automation-id="facility-description"
          ></div>
          <hr class="my-3" />
        </div>
        <p class="text-primary mt-6 mb-5 fw-600" data-automation-id="24/7">
          24/7 Emergency Response
        </p>
        <a
          href="tel: +18008994672"
          class="text-decoration-none fw-600 mb-5 hover-bold"
          >800.899.4672</a
        >
      </div>
    </div>
  </div>
  <div class="mt-15" *ngIf="facility.services">
    <digital-platform-facility-services-available
      [servicesAvailable]="facility.services"
    ></digital-platform-facility-services-available>
  </div>
  <div class="container">
    <digital-platform-facility-contact-us></digital-platform-facility-contact-us>
  </div>
</section>
